import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinmumbai() {



const cardData = {
  keyword: " Kia Carens On Rent in Mumbai  ",

headingDescription: "Velocity Cab provides reliable and comfortable Kia Carens on rent in Mumbai, offering a perfect blend of modern design, spacious interiors, and smooth performance for families, corporate groups, airport transfers, and outstation journeys. Our well-maintained Kia Carens vehicles come with comfortable seating, advanced features, and ample luggage space, ensuring a pleasant travel experience for both short city rides and long-distance trips. With professional drivers, punctual service, and clean vehicles, we make your journey stress-free and enjoyable. We offer flexible booking options including hourly rentals, full-day packages, one-way trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kia Carens rental in Mumbai.",

topPlaces: [
  {
    title: "Lavasa",
    description: "Lavasa is a picturesque planned hill city surrounded by the Sahyadri Hills, offering beautiful lakeside views, colorful architecture, and adventure activities. Travelers booking a sedan cab from Mumbai can enjoy a scenic drive and relax with boating, cycling, and waterfront walks."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a tranquil hill retreat known for Arthur Lake, Randha Falls, and Wilson Dam. Nature lovers can enjoy breathtaking landscapes, camping, and peaceful surroundings, making it a perfect weekend getaway from Mumbai."
  },
  {
    title: "Jawhar",
    description: "Jawhar is a charming hill station in Maharashtra famous for its waterfalls, lush forests, and tribal culture. Visitors can explore Jai Vilas Palace, Dabhosa Waterfall, and Hanuman Point while enjoying a refreshing escape from city life."
  },
  {
    title: "Kolad",
    description: "Kolad is an adventure destination near Mumbai renowned for white-water rafting on the Kundalika River. Travelers can also enjoy kayaking, ziplining, and camping, making it an excellent destination for thrill seekers."
  },
  {
    title: "Harihareshwar",
    description: "Harihareshwar is a peaceful coastal town known for its pristine beaches and the ancient Harihareshwar Temple. It offers a perfect blend of spirituality, scenic beauty, and relaxing seaside experiences."
  },
  {
    title: "Diveagar",
    description: "Diveagar is a serene beach destination featuring golden sands, coconut groves, and a peaceful atmosphere. It is ideal for families and couples looking to unwind by the Arabian Sea."
  },
  {
    title: "Murud-Janjira",
    description: "Murud-Janjira is famous for the magnificent Janjira Fort built on an island in the Arabian Sea. Visitors can enjoy boat rides to the fort, explore its fascinating history, and relax on the nearby beaches."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is one of Maharashtra’s most beautiful beach destinations, known for crystal-clear waters, scuba diving, snorkeling, and houseboat experiences. It is a paradise for beach lovers and water sports enthusiasts."
  },
  {
    title: "Ganpatipule",
    description: "Ganpatipule is a popular pilgrimage and beach destination famous for the self-originated Ganpati Temple and its pristine coastline. Travelers can enjoy spiritual visits along with relaxing beach experiences."
  },
  {
    title: "Amboli",
    description: "Amboli is a scenic hill station in the Western Ghats known for mist-covered hills, waterfalls, dense forests, and pleasant weather. It is an excellent destination for nature lovers, photographers, and monsoon travelers."
  }
],



services: [
{
name: "Kia Carens on Rent Mumbai",
description: "Kia Carens on rent Mumbai offers a perfect blend of comfort, style, and practicality for family and group travel. This modern multi-purpose vehicle is ideal for airport transfers, city travel, and outstation trips from Mumbai. With spacious seating, premium interiors, and smooth suspension, Kia Carens ensures a relaxed journey even on long routes. Professional drivers ensure safe and timely travel across city and highway routes. Customers can choose flexible rental options including hourly, daily, and outstation packages. Pickup is available from Mumbai Airport, railway stations, and residential locations. With transparent pricing and easy booking, this service provides a comfortable and premium travel experience."
},
{
name: "Kia Carens Cab Service Mumbai",
description: "Kia Carens cab service Mumbai provides reliable and comfortable transportation for families and small groups. This service is suitable for local travel, airport transfers, and long-distance trips. The vehicle offers spacious seating and modern features for a smooth ride. Professional drivers ensure safe and efficient travel across all routes. Flexible booking options allow customers to plan trips easily. It is a preferred choice for comfortable group travel."
},
{
name: "Kia Carens Taxi Mumbai",
description: "Kia Carens taxi Mumbai offers a stylish and comfortable travel option for both city and outstation journeys. The vehicle provides ample seating space and smooth ride quality, making it ideal for families. Drivers ensure safe navigation through city traffic and highways. Customers can enjoy door-to-door pickup and flexible travel timings. Affordable pricing and easy booking enhance convenience. It is a reliable taxi service for modern travel needs."
},
{
name: "6 Seater Kia Carens Cab Mumbai",
description: "6 seater Kia Carens cab Mumbai is perfect for families and small groups looking for comfortable and spacious travel. The vehicle offers good legroom, modern interiors, and smooth ride quality for long journeys. This service is ideal for airport transfers and city rides. Professional drivers ensure safe and timely service. Flexible rental options make it convenient for customers. It provides a great balance of comfort and capacity."
},
{
name: "7 Seater Kia Carens Rental Mumbai",
description: "7 seater Kia Carens rental Mumbai is ideal for larger families and groups needing extra seating space. The vehicle offers comfortable seating, ample luggage space, and modern features for a smooth journey. This service is suitable for long-distance and city travel. Professional drivers ensure safe driving and punctual service. Flexible rental plans are available for different needs. It ensures a comfortable group travel experience."
},
{
name: "Kia Carens Airport Pickup Mumbai",
description: "Kia Carens airport pickup Mumbai provides reliable and comfortable airport transfer services for families and groups. This service ensures timely pickup and drop at Mumbai Airport with spacious seating and luggage capacity. Drivers track flight timings for smooth coordination. Clean and well-maintained vehicles enhance the travel experience. Flexible booking options are available. It ensures a hassle-free airport journey."
},
{
name: "Cheap Kia Carens on Rent Mumbai",
description: "Cheap Kia Carens on rent Mumbai offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers who want a modern vehicle at affordable rates. Well-maintained vehicles and professional drivers ensure smooth travel. Transparent pricing ensures no hidden charges. Flexible rental plans are available for different needs. It is a perfect combination of affordability and comfort."
},
{
name: "Kia Carens for Outstation Mumbai",
description: "Kia Carens for outstation Mumbai offers long-distance travel solutions with comfort and efficiency. This service is ideal for trips to destinations like Pune, Lonavala, Nashik, Shirdi, and Goa. The vehicle provides smooth performance and comfortable seating for extended journeys. Professional drivers ensure safe driving on highways and ghat roads. Flexible packages include one way and round trip options. It ensures a comfortable and stress-free travel experience."
},
{
name: "Book Kia Carens Cab Mumbai",
description: "Book Kia Carens cab Mumbai for quick and hassle-free reservations with instant confirmation and flexible travel options. Customers can choose pickup location, travel date, and vehicle type conveniently. Online booking platforms provide secure payment and transparent pricing. This service ensures availability of vehicles when needed. Dedicated support is available for assistance. It is the most convenient way to book a Kia Carens cab."
},
{
name: "Kia Carens with Driver Mumbai",
description: "Kia Carens with driver Mumbai provides a complete travel solution with professional chauffeurs ensuring safe and comfortable journeys. Drivers are experienced and familiar with city and outstation routes for smooth navigation. This service allows customers to relax and enjoy their trip without worrying about driving. Flexible rental options are available based on travel needs. Clean and well-maintained vehicles enhance the experience. It ensures a premium and stress-free travel experience."
}
],

tableData: [
["Kia Carens on Rent Mumbai","Kia Carens Cab Service Mumbai"],
["Kia Carens Taxi Mumbai","6 Seater Kia Carens Cab Mumbai"],
["7 Seater Kia Carens Rental Mumbai","Kia Carens Airport Pickup Mumbai"],
["Cheap Kia Carens on Rent Mumbai","Kia Carens for Outstation Mumbai"],
["Book Kia Carens Cab Mumbai","Kia Carens with Driver Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Kia Carens for Mumbai Travel",
    WhyChoosedescription: "Velocity Cabs offers Kia Carens on rent in Mumbai with premium comfort, spacious seating, and modern interiors, making it perfect for family trips, airport transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for Kia Carens rental in Mumbai. Customers receive complete fare details including per km charges, toll charges, and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Kia Carens rental service in Mumbai operates 24/7. Whether you need airport transfer, business travel, or late-night rides, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Velocity Cabs offers flexible rental options including local travel (8 hours/80 km), outstation trips, one-way travel, round-trip bookings, and customized packages."
  },
  {
    WhyChooseheading: "Ideal for Family & Group Travel",
    WhyChoosedescription: "Kia Carens is ideal for families and small groups with seating capacity for 6 to 7 passengers and sufficient luggage space for long-distance travel."
  },
  {
    WhyChooseheading: "Trusted Car Rental Service in Mumbai",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Kia Carens on rent in Mumbai due to professional drivers, clean vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide Kia Carens on rent in Mumbai?", answer: "Yes, Velocity Cabs provides Kia Carens rental services in Mumbai for local and outstation travel." },
  { question: "What is the price of Kia Carens on rent in Mumbai?", answer: "The rental cost typically starts from ₹15 to ₹20 per km or ₹2200 to ₹4000 per day depending on the package and duration." },
  { question: "How many passengers can travel in Kia Carens?", answer: "Kia Carens can comfortably accommodate 6 to 7 passengers along with luggage." },
  { question: "Is Kia Carens available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Mumbai using Kia Carens vehicles." },
  { question: "Can I book Kia Carens for outstation trips?", answer: "Yes, Kia Carens is available for outstation travel from Mumbai to destinations like Pune, Shirdi, Goa, Mahabaleshwar, and Nashik." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our Kia Carens rental service in Mumbai operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Kia Carens vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Kia Carens online?", answer: "Yes, customers can easily book Kia Carens on rent in Mumbai online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback:
      "Spacious and comfortable ride experience with the Kia Carens on rent in Mumbai. The vehicle felt premium, clean, and perfect for family travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "The Kia Carens rental in Mumbai offered a very smooth and comfortable journey. Seating was excellent, and the overall travel experience was hassle-free and enjoyable.",
    rating: 5
  }
];

























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const kiaCarensMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Kia Carens On Rent in Mumbai | Velocity Cabs",
  "description": "Rent a Kia Carens in Mumbai for airport pickups, outstation trips, or city travel. 6-seater and 7-seater AC options with driver available at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Kia Carens Rental Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Kia Carens Rental",
        "description": "Rent a Kia Carens for one-way travel in Mumbai with 6-seater or 7-seater AC options and private driver.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Kia Carens Rental",
        "description": "Comfortable round-trip rental of Kia Carens in Mumbai with private driver and 6-seater or 7-seater AC options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Kia Carens On Rent in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a Kia Carens in Mumbai for airport pickups, outstation trips, or city travel. 6-seater and 7-seater AC options with driver available at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(kiaCarensMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinmumbai;